import { TYPE } from "components/Form";
import {
  FLAG_FILTER_OPTIONS,
  GEO_LOCATION_FILTER_DEFAULTS,
  GLOBAL_VALUE_TYPES,
  USER_TYPES_WITH_FILTER_ACCESS,
} from "constants/index";

const NETWORK_LIST_FILTERS_CONFIG = {
  status: {
    label: "Status",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ status }) => status,
    showOperator: true,
    properties: {
      placeholder: "Type a status...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  location: {
    label: "Locality",
    type: TYPE.geoLocator,
    valuesType: GLOBAL_VALUE_TYPES.geoLocation,
    transformValues: ({ latitude, longitude } = {}) => ({
      latitude,
      longitude,
      radius: GEO_LOCATION_FILTER_DEFAULTS.radius,
      unit: GEO_LOCATION_FILTER_DEFAULTS.unit,
    }),
    showOperator: false,
    properties: {
      label: "",
      localityOnly: true,
      isClearable: true,
      labelKey: "value",
      valueKey: "value",
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin],
    },
  },
  is_open_to_employment: {
    label: "Is Open to Full-time Employment?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [
        USER_TYPES_WITH_FILTER_ACCESS.admin,
        USER_TYPES_WITH_FILTER_ACCESS.recruiter,
        USER_TYPES_WITH_FILTER_ACCESS.showcase,
        USER_TYPES_WITH_FILTER_ACCESS.client,
        USER_TYPES_WITH_FILTER_ACCESS.signal,
      ],
    },
  },
  selling_price_hourly_usd: {
    label: ({ isShowcase }) => `Hourly ${isShowcase ? "" : "Selling "}Rate (USD)`,
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.showcase],
    },
  },
  hourly_rate_eur: {
    label: "Hourly Rate (EUR)",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  hourly_rate_cad: {
    label: "Hourly Rate (CAD)",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  skills: {
    label: "Skills",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ skills }) => skills,
    showOperator: true,
    properties: {
      placeholder: "Type a skill...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [
        USER_TYPES_WITH_FILTER_ACCESS.admin,
        USER_TYPES_WITH_FILTER_ACCESS.recruiter,
        USER_TYPES_WITH_FILTER_ACCESS.showcase,
        USER_TYPES_WITH_FILTER_ACCESS.client,
        USER_TYPES_WITH_FILTER_ACCESS.signal,
      ],
    },
  },
  first_name: {
    label: "First Name",
    type: TYPE.input,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => [value],
    showOperator: false,
    properties: {
      placeholder: "Type a first name...",
      minLength: 0,
      withButton: true,
    },
    restrict: {
      roles: [
        USER_TYPES_WITH_FILTER_ACCESS.admin,
        USER_TYPES_WITH_FILTER_ACCESS.recruiter,
        USER_TYPES_WITH_FILTER_ACCESS.showcase,
        USER_TYPES_WITH_FILTER_ACCESS.client,
        USER_TYPES_WITH_FILTER_ACCESS.signal,
      ],
    },
  },
  last_name: {
    label: "Last Name",
    type: TYPE.input,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => [value],
    showOperator: false,
    properties: {
      placeholder: "Type a last name...",
      minLength: 0,
      withButton: true,
    },
    restrict: {
      roles: [
        USER_TYPES_WITH_FILTER_ACCESS.admin,
        USER_TYPES_WITH_FILTER_ACCESS.recruiter,
        USER_TYPES_WITH_FILTER_ACCESS.showcase,
        USER_TYPES_WITH_FILTER_ACCESS.client,
        USER_TYPES_WITH_FILTER_ACCESS.signal,
      ],
    },
  },
  disciplines: {
    label: "Disciplines",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ disciplines }) => disciplines,
    showOperator: true,
    properties: {
      placeholder: "Type a discipline...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [
        USER_TYPES_WITH_FILTER_ACCESS.admin,
        USER_TYPES_WITH_FILTER_ACCESS.recruiter,
        USER_TYPES_WITH_FILTER_ACCESS.showcase,
        USER_TYPES_WITH_FILTER_ACCESS.client,
        USER_TYPES_WITH_FILTER_ACCESS.signal,
      ],
    },
  },
  archetype: {
    label: "Archetype",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ archetype }) => archetype,
    showOperator: true,
    properties: {
      placeholder: "Type an archetype...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [
        USER_TYPES_WITH_FILTER_ACCESS.admin,
        USER_TYPES_WITH_FILTER_ACCESS.recruiter,
        USER_TYPES_WITH_FILTER_ACCESS.showcase,
        USER_TYPES_WITH_FILTER_ACCESS.client,
        USER_TYPES_WITH_FILTER_ACCESS.signal,
      ],
    },
  },
  country: {
    label: "Country",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ country }) => country,
    showOperator: true,
    properties: {
      placeholder: "Type a country...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [
        USER_TYPES_WITH_FILTER_ACCESS.admin,
        USER_TYPES_WITH_FILTER_ACCESS.recruiter,
        USER_TYPES_WITH_FILTER_ACCESS.showcase,
        USER_TYPES_WITH_FILTER_ACCESS.client,
        USER_TYPES_WITH_FILTER_ACCESS.signal,
      ],
    },
  },
  world_region: {
    label: "Region",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ worldRegion }) => worldRegion,
    showOperator: true,
    properties: {
      placeholder: "Type a region...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [
        USER_TYPES_WITH_FILTER_ACCESS.admin,
        USER_TYPES_WITH_FILTER_ACCESS.recruiter,
        USER_TYPES_WITH_FILTER_ACCESS.showcase,
        USER_TYPES_WITH_FILTER_ACCESS.client,
        USER_TYPES_WITH_FILTER_ACCESS.signal,
      ],
    },
  },
  industries: {
    label: "Industries",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ industries }) => industries,
    showOperator: true,
    properties: {
      placeholder: "Type an industry...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [
        USER_TYPES_WITH_FILTER_ACCESS.admin,
        USER_TYPES_WITH_FILTER_ACCESS.recruiter,
        USER_TYPES_WITH_FILTER_ACCESS.showcase,
        USER_TYPES_WITH_FILTER_ACCESS.client,
        USER_TYPES_WITH_FILTER_ACCESS.signal,
      ],
    },
  },
  experience_years: {
    label: "Years of Experience",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    properties: {
      type: "number",
    },
    restrict: {
      roles: [
        USER_TYPES_WITH_FILTER_ACCESS.admin,
        USER_TYPES_WITH_FILTER_ACCESS.recruiter,
        USER_TYPES_WITH_FILTER_ACCESS.showcase,
        USER_TYPES_WITH_FILTER_ACCESS.client,
        USER_TYPES_WITH_FILTER_ACCESS.signal,
      ],
    },
  },
  time_zone: {
    label: "Time Zone",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ timeZone }) => timeZone,
    showOperator: true,
    properties: {
      placeholder: "Type a time zone...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [
        USER_TYPES_WITH_FILTER_ACCESS.admin,
        USER_TYPES_WITH_FILTER_ACCESS.recruiter,
        USER_TYPES_WITH_FILTER_ACCESS.showcase,
        USER_TYPES_WITH_FILTER_ACCESS.client,
        USER_TYPES_WITH_FILTER_ACCESS.signal,
      ],
    },
  },
  offboarded_at: {
    label: "Pending At",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.dateValues,
    transformValues: ({ min, max }) => [min || null, max || null],
    properties: {
      component: TYPE.datePicker,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  onboarded_at: {
    label: "Onboarded At",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.dateValues,
    transformValues: ({ min, max }) => [min || null, max || null],
    properties: {
      component: TYPE.datePicker,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  rejected_candidate_date: {
    label: "Rejected Candidate Date",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.dateValues,
    transformValues: ({ min, max }) => [min || null, max || null],
    properties: {
      component: TYPE.datePicker,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  member_date: {
    label: "Member Date",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.dateValues,
    transformValues: ({ min, max }) => [min || null, max || null],
    properties: {
      component: TYPE.datePicker,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  skill_assessments_passed: {
    label: "Skills Assessment",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ skills }) => skills,
    showOperator: true,
    properties: {
      placeholder: "Type a skill...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  continent: {
    label: "Continent",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ continent }) => continent,
    showOperator: true,
    properties: {
      placeholder: "Type a continent...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  recent_skills: {
    label: "Recent Skills",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ recent_skills }) => recent_skills,
    showOperator: true,
    properties: {
      placeholder: "Type a recent skill...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  lists: {
    label: "Lists",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ lists }) => lists,
    showOperator: true,
    properties: {
      placeholder: "Type a list name...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  partner: {
    label: "Partner",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ partner }) => partner,
    showOperator: true,
    properties: {
      placeholder: "Type a partner name...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  partner_type: {
    label: "Partner Type",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ partnerType }) => partnerType,
    showOperator: true,
    properties: {
      placeholder: "Type a partner type...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  role: {
    label: "Role",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ role }) => role,
    showOperator: true,
    properties: {
      placeholder: "Type a role...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  acquisition_channel: {
    label: "Acquisition Channel",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ acquisitionChannel }) => acquisitionChannel,
    showOperator: true,
    properties: {
      placeholder: "Type an acquisition channel...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  acquisition_source: {
    label: "Acquisition Source",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ acquisitionSource }) => acquisitionSource,
    showOperator: true,
    properties: {
      placeholder: "Type an acquisition source...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  active_mission_count: {
    label: "Active Mission Count",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  mission_board_application_count: {
    label: "Application Count",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  mission_board_invitation_count: {
    label: "Invitation Count",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  experience_job_count: {
    label: "Job Experience",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  available_hours: {
    label: "Available Hours",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  active_teams: {
    label: "Active Teams",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ activeTeams }) => activeTeams,
    showOperator: true,
    properties: {
      placeholder: "Type an active team...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  archive_reason: {
    label: "Archive Reason",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ archiveReason }) => archiveReason,
    showOperator: true,
    properties: {
      placeholder: "Type an archive reason...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  badges: {
    label: "Badges",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ badges }) => badges,
    showOperator: true,
    properties: {
      placeholder: "Type a badge...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  languages: {
    label: "Languages",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ languages }) => languages,
    showOperator: true,
    properties: {
      placeholder: "Type a language...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  interests: {
    label: "Work Interests",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ interests }) => interests,
    showOperator: true,
    properties: {
      placeholder: "Type an interest...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  profile_status: {
    label: "Profile Status",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    showOperator: true,
    properties: {
      placeholder: "Type a status...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
      options: [
        { label: "Members", value: "is_member" },
        { label: "Candidates", value: "is_candidate" },
        { label: "Rejected Candidates", value: "is_rejected_candidate" },
        { label: "Kicked Out Members", value: "is_kicked_out_member" },
      ],
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  engineering_levels: {
    label: "Engineering Levels",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ engineeringLevels }) => engineeringLevels,
    showOperator: true,
    properties: {
      placeholder: "Type an engineering level...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  is_available: {
    label: "Is Available?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  is_assigned: {
    label: "Is Assigned?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  has_been_assigned: {
    label: "Has Been Assigned?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  is_from_partner: {
    label: "Is Coming From Partner?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  has_accepted_privacy_policy: {
    label: "Has Accepted Privacy Policy?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  has_been_candidate: {
    label: "Has Been Candidate?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  assigned_to: {
    label: "Talent Owner",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ assignedTo }) => assignedTo,
    showOperator: true,
    properties: {
      placeholder: "Type a name...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  is_candidate_ready_for_review: {
    label: "Is Candidate Ready for Review?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  has_passed_skill_assessment: {
    label: "Has Passed Skill Assessment?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  is_profile_complete: {
    label: "Is Profile Complete?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
  has_video_interviews: {
    label: "Has Video Interviews?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [
        USER_TYPES_WITH_FILTER_ACCESS.admin,
        USER_TYPES_WITH_FILTER_ACCESS.recruiter,
        USER_TYPES_WITH_FILTER_ACCESS.showcase,
        USER_TYPES_WITH_FILTER_ACCESS.client,
        USER_TYPES_WITH_FILTER_ACCESS.signal,
      ],
    },
  },
  is_flagged: {
    label: "Is Flagged?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin, USER_TYPES_WITH_FILTER_ACCESS.recruiter],
    },
  },
};

const STICKY_NETWORK_FILTER_KEYS = ["country", "disciplines", "skills", "world_region"];

const NETWORK_LIST_SORTING_OPTIONS = [
  {
    label: "Relevance Score",
    value: "_score",
  },
  {
    label: "Created at",
    value: "candidate_at",
  },
  {
    label: "Member since",
    value: "member_at",
  },
  {
    label: "Last name",
    value: "last_name",
  },
  {
    label: "Rate",
    value: "hourly_rate",
  },
  {
    label: "Showcase score",
    value: "showcase_score",
  },
];

const NETWORK_LIST_SORTING_VALUES = NETWORK_LIST_SORTING_OPTIONS.reduce((acc, { value }) => {
  acc[value] = value;
  return acc;
}, {});

const NETWORK_LIST_BADGES_OPTIONS = {
  featured: "Featured",
};

const NETWORK_LIST_STATUS_OPTIONS = {
  member: "Member",
};

export {
  STICKY_NETWORK_FILTER_KEYS,
  NETWORK_LIST_SORTING_OPTIONS,
  NETWORK_LIST_SORTING_VALUES,
  NETWORK_LIST_BADGES_OPTIONS,
  NETWORK_LIST_STATUS_OPTIONS,
};

export default NETWORK_LIST_FILTERS_CONFIG;
